import type {MouseEvent, TouchEvent} from "react";

export const isInteractiveNode = (node: HTMLElement) => {
  switch (node.nodeName) {
    case "BUTTON":
    case "A":
    case "TEXTAREA":
    case "INPUT":
    case "SELECT":
      return true;
    default:
      if (node.getAttribute("contenteditable") || node.dataset?.cdxClickable === "true") {
        return true;
      } else {
        return false;
      }
  }
};

export const isEventWithinInteractiveNode = (
  e: MouseEvent | TouchEvent | KeyboardEvent | ClipboardEvent,
  opts: {ignoreLink?: boolean} = {ignoreLink: false}
) => {
  const {nodeName} = e.target as HTMLElement;
  if (nodeName === "TEXTAREA" || nodeName === "INPUT" || nodeName === "SELECT") return true;
  let current = e.target as HTMLElement | null;
  while (current) {
    if (
      current.nodeName === "BUTTON" ||
      (!opts.ignoreLink && current.nodeName === "A") ||
      current.getAttribute("contenteditable") ||
      current.dataset?.cdxClickable === "true" || // for cases like `<div onClick={onClick} data-cdx-clickable>`
      current.classList?.contains("os-scrollbar")
    )
      return true;
    current = current.parentElement;
  }
  return false;
};
